import {Badge, Button, TableCell, TableRow} from "@mui/material";
import {MdEmail, MdPhone} from "react-icons/md";
import * as React from "react";
import VoucherMarkAsUnused from "../Helpers/VoucherMarkAsUnused";
import moment from "moment/moment";

export default function VouchersTableShowTableRow({ row, onClick, setLoadingVouchers }) {

    const [markUnused, setMarkUnused] = React.useState(false);
    // Use a moment object for now so we can compare to expiry + 6 months
    const now = moment().utcOffset("+12:00");
    // if(searchTerm==='') return null;
    return (
        <TableRow>
            <TableCell align="left">
                {row.sn}
                {
                    (row.sn_duplicate !== null && row.sn_duplicate !== row.sn && row.sn_duplicate !== '') ?
                        <div style={{color: 'red', fontWeight: 'bold'}}>This voucher number has changed. The number the
                            client presents is {row.sn_duplicate}.</div>
                        : undefined
                }
                {
                    (row?.marked_unused != 1) ?
                    <>
                        <div><a href={"#"} onClick={(e) => {e.preventDefault(); setMarkUnused(true)}}>Mark unused</a></div>
                        {markUnused && <VoucherMarkAsUnused key={row.id} open={markUnused} setOpen={setMarkUnused} voucher={row} setLoadingVouchers={setLoadingVouchers} />}
                    </>
                        :
                        <div style={{color:'red'}}>Unused voucher</div>
                }
                <button className={"vet-info-button"} style={{marginTop:20}}>
                    {row.campaign_target !== 'community' && row.campaign_target !== 'inspectors' && row.campaign_target !== 'outreach' && "Public"}
                    {row.campaign_target === 'community' && "Community"}
                    {row.campaign_target === 'inspectors' && "Inspector"}
                    {row.campaign_target === 'outreach' && "Outreach"}
                </button>
            </TableCell>
            <TableCell align="left" style={{whiteSpace: 'nowrap'}}>
                {
                    (
                        (
                            row.sponsor_id > 0 &&
                            row.sponsor_applicant_cost > 0 &&
                            row.sponsor_microchip_extra_cost > -999
                        )
                        || ['community', 'inspectors','outreach'].includes(row.campaign_target)
                    ) ?
                        <span style={{color: 'red'}}>No client fee</span>
                        :
                        <span style={{opacity: 0.3}}>Client pays fee.</span>
                }
            </TableCell>
            <TableCell align="left">
                <b>
                    {(row.is_redeemed > 0) ? row.owner_first : row.first}&nbsp;
                    {(row.is_redeemed > 0) ? row.owner_last : row.last}
                </b><br/>
                <span style={{whiteSpace: 'nowrap'}}><MdEmail/> <a
                    href={"mailto:" + (row.is_redeemed > 0) ? row.owner_email : row.email}
                    target={"_blank"}
                    rel={"noreferrer"}>{(row.is_redeemed > 0) ? row.owner_email : row.email}</a></span><br/>
                <span
                    style={{whiteSpace: 'nowrap'}}><MdPhone/> {(row.is_redeemed > 0) ? row.owner_phone : row.phone}</span>
            </TableCell>
            <TableCell align="left">{new Date(row.created_at).toLocaleDateString("en-NZ")}</TableCell>
            <TableCell align="left">
                <div>
                {row.a_microchip_only_flag > 0 ? <p style={{marginTop: 0, color:'red'}}>Microchip only</p> : undefined}
                </div>
                <div style={{display: 'flex', flex: '1 0 100%', flexWrap: 'wrap'}}>
                    <button className={"vet-info-button"}>Name {row.a_name}:</button>
                    <button className={"vet-info-button"}>Type: {row.a_type}</button>
                    <button className={"vet-info-button"}>Sex: {row.a_gender}</button>
                    <button className={"vet-info-button"}>Age: {row.a_age}</button>
                    <button className={"vet-info-button"}>Primary color: {row.a_color_primary}</button>
                    {(row.a_color_secondary !== '') ? <button className={"vet-info-button"}>Secondary
                        color: {row.a_color_secondary}</button> : undefined}
                    <button
                        className={"vet-info-button"}>Microchipped: {(row.a_microchipped > 0) ? "Yes" : "No"}</button>
                    <button className={"vet-info-button"}>Is
                        pregnant: {(row.a_is_pregnant > 0) ? "Yes" : "No"}</button>
                    <button className={"vet-info-button"}>Was pregnant in the last 6
                        weeks: {(row.a_was_pregnant > 0) ? "Yes" : "No"}</button>
                </div>
            </TableCell>
            <TableCell align="right">
    { row.is_cancelled === 1 ? (
        <Button
          variant="contained"
          disabled
          sx={{ backgroundColor: 'red', color: 'white' }}
        >
          Cancelled
        </Button>
            ) : (now.isAfter(moment(row.expiry_date).add(6, 'months')) && !(row.is_redeemed > 0)) ? 
                <Button variant="contained" disabled sx={{ backgroundColor: 'grey', color: 'white' }}>
            Expired
        </Button> 
        : 
        <Button variant="contained" onClick={onClick}>Redeem</Button>
    }
</TableCell>
        </TableRow>
    )
}
